export default "__VITE_ASSET__D6jK7kB1__"